import { RootState } from '../rootReducer';

export const selectDefense = (state: RootState) => state.defense.defense.defense;
